import { render, staticRenderFns } from "./magicCubeConfig.vue?vue&type=template&id=4c3aab77&scoped=true"
import script from "./magicCubeConfig.vue?vue&type=script&lang=js"
export * from "./magicCubeConfig.vue?vue&type=script&lang=js"
import style0 from "./magicCubeConfig.vue?vue&type=style&index=0&id=4c3aab77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3aab77",
  null
  
)

export default component.exports